//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TransientObject.js";
let d=[[[0,"CurveType",0,0]],[[[],"Dispose",{},0,0],[["numParents"],"GetParents",{R_:{parents:"NXObject[]"}},0,0]],[]];
SPLM.Drawings.DraftingCurveInfo = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.DraftingCurveInfo";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.DraftingCurveInfo.DraftingCurveType = Object.freeze({
    "NonDraftingCurve" : "NonDraftingCurve", "ExtractedEdge" : "ExtractedEdge", "ExtractedModelCurve" : "ExtractedModelCurve", "SilhouetteCurve" : "SilhouetteCurve", "ThreadSilhouetteCurve" : "ThreadSilhouetteCurve", "SectionEdge" : "SectionEdge", "ThreadSectionEdge" : "ThreadSectionEdge", "VICurve" : "VICurve", "UVHatchCurve" : "UVHatchCurve", "TracelineCurve" : "TracelineCurve", "SimplifiedCurve" : "SimplifiedCurve", "InterferenceCurve" : "InterferenceCurve", "ExtractedPoint" : "ExtractedPoint"});

export default SPLM;